import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { fmtEuro } from "@/lib/adminApi";

const ChartTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-slate-200 bg-white px-3 py-2 shadow-md">
      <p className="text-xs font-medium text-slate-500">{label}</p>
      <p className="text-sm font-bold text-[#0a2540]">{fmtEuro(payload[0].value)}</p>
    </div>
  );
};

const RevenueChart = ({ data }) => {
  const hasData = (data || []).some((d) => d.revenue > 0);
  return (
    <div className="mb-8 rounded-xl border border-slate-200 bg-white p-5" data-testid="revenue-chart">
      <div className="mb-4 flex items-baseline justify-between">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Omzet per maand</h2>
        <span className="text-xs text-slate-400">Laatste 12 maanden</span>
      </div>
      {!hasData ? (
        <div className="flex h-[240px] items-center justify-center text-sm text-slate-400"
          data-testid="revenue-chart-empty">
          Nog geen betaalde omzet om te tonen
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eef2f6" />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false}
              width={48} tickFormatter={(v) => `€${v}`} />
            <Tooltip content={<ChartTooltip />} cursor={{ fill: "#0a5a3c0d" }} />
            <Bar dataKey="revenue" fill="#0a5a3c" radius={[6, 6, 0, 0]} maxBarSize={44} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default RevenueChart;
